module.exports = "/assets/e1cf0883c9bb5b2b04549804cb8ce3ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/XQ.png
// module id = 3123
// module chunks = 0